import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "23",
  height: "30",
  viewBox: "0 0 23 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.8791 18.5606C22.8791 24.8785 17.7574 30.0002 11.4396 30.0002C5.12166 30.0002 0 24.8785 0 18.5606C0 12.2428 5.12166 7.12109 11.4396 7.12109C14.8065 7.12109 11.9293 15.8766 14.0227 18.1916C15.8574 20.2206 22.8791 15.6097 22.8791 18.5606Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.8639 19.6756C13.847 19.6927 13.8301 19.7097 13.8131 19.7267L3.94968 9.8633L13.8131 -8.9768e-05C18.0046 4.19144 18.9709 10.3868 16.7121 15.5023L20.094 12.1204C23.9007 15.9271 23.9007 22.099 20.094 25.9057L13.8639 19.6756Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }